export default __webpack_public_path__ + "static/media/mod-kaydet.3a443bb2.png";